import React from 'react';
import {BaseMixin, ElementaryMixin, NestingLevelMixin, SectionMixin, ColorSchemaMixin} from '../common/common.js';
import Environment from '../environment/environment.js';
import Tools from '../common/tools.js';
import {Div} from './bricks.js';

import './section.less';

export const Section = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin,
    SectionMixin,
    ColorSchemaMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Section',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'box'),
    classNames: {
      main: 'uu5-bricks-section'
    },
    opt: {
      nestingLevelWrapper: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getPropsToPass() {
    return Tools.merge(this.getMainPropsToPass(),{content:null,header:null,footer:null});
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
        <Div {...this._getPropsToPass()}>
          {this.getHeaderChild()}
          {this.getChildren()}
          {this.getFooterChild()}
          {this.getDisabledCover()}
        </Div>
      ) : null
    );
  }
  //@@viewOff:render
});

export default Section;



// WEBPACK FOOTER //
// ./bricks/section.js